import { AvaibilityType } from "../../../explorer/types/Basket/BasketItems";

export type WarrantyItem = {
    //#region BackEndProps
    code: string,
    manufacturerCompanyCode: string,
    qty: number,
    unitOfMeasure?: string,
    note: string,
    //#endregion
    rowId: string,
    navContext?: string,
    machineSN?: string,
    table?: string,
    position?: string,
    partDescription: string;
    currency: string,
    netTotalPrice?: number,
    grossUnitPrice?: number,
    hidePrice?: boolean;
    availabilityStatus?: AvaibilityType;
    outOfWarranty?: boolean;    
};

export enum WarrantyItemType {
    MissingPartWrongMaterial = "Missing parts/Wrong material",
    DamagedAndBroken = "Damaged and broken parts in warranty"
}

//#region Warranty Missing Parts or Wrong Material
export enum WarrantyReason {
    MissingPart = "MissingPart",
    WrongMaterial = "WrongMaterial",
}

export interface WarrantyItemForMissing extends WarrantyItem {
    case?: WarrantyReason;
    expectedQuantity?: number | null;
    quantityReceived?: number | null;
    required?: number;
    scrappedMaterialOnSite?: boolean;
}

//#endregion

//#region Warranty Demeged and Broken Parts
export enum DefectType {
    BrokenDuringTransport = "BrokenDuringTransport",
    OnFirstStartUp = "OnFirstStartUp",
    DuringStartUpFirstWeek = "DuringStartUpFirstWeek",
    DefectiveUnderWarranty = "DefectiveUnderWarranty",
}

export enum PriorityType {
    High = "High",
    Medium = "Medium",
    Low = "Low",
}

export interface WarrantyItemForDamaged extends WarrantyItem {
    scrappedMaterialOnSite?: boolean;
    damageType?: DefectType;
    priority?: PriorityType;
}

//#endregion